<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Edit</h2> 
                <h4>Visit Frequency</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <!--  needs-validation -->
                <div class="form-group row">
                    <label for="red" class="col-sm-2 col-form-label">Red</label> 
                    <div class="col-sm-6">
                        <input type="text" id="red" required="required" class="form-control"  
                            :class="{'is-invalid': redHasError}"
                            v-model="red"
                            :disabled="this.loading" > 
                        <form-error name="red" :errors="errors"></form-error>
                    </div>
                </div> 
                <div class="form-group row">
                    <label for="amber" class="col-sm-2 col-form-label">Amber</label> 
                    <div class="col-sm-6">
                        <input type="text" id="amber" required="required" class="form-control"  
                            :class="{'is-invalid': amberHasError}"
                            v-model="amber"
                            :disabled="this.loading" > 
                        <form-error name="amber" :errors="errors"></form-error>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="green" class="col-sm-2 col-form-label">Green</label> 
                    <div class="col-sm-6">
                        <input type="text" id="green" required="required" class="form-control"  
                            :class="{'is-invalid': greenHasError}"
                            v-model="green"
                            :disabled="this.loading" > 
                        <form-error name="green" :errors="errors"></form-error>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="blue" class="col-sm-2 col-form-label">Blue</label> 
                    <div class="col-sm-6">
                        <input type="text" id="blue" required="required" class="form-control"  
                            :class="{'is-invalid': blueHasError}"
                            v-model="blue"
                            :disabled="this.loading" > 
                        <form-error name="blue" :errors="errors"></form-error>
                    </div>
                </div> 
                <div class="form-group row">
                    <div class="col-sm-10 offset-sm-2">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </div> 
                <router-link :to="{name:'home'}">Back</router-link>
            </form>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError"
import VisitFrequencyService from "../../../services/VisitFrequencyService"

export default {
    data: function () {
        return {
            loading: false,
            red: '',
            amber: '',
            green: '',
            blue: '',
            errors: {},
        }
    },
    
    components: {FormError},

    mounted(){
        this.load();
    },

    methods: {
        submit: function () {
            VisitFrequencyService.update(this.formData())
                .then( ({data}) => this.success(data) )
                .catch( ({response}) => this.failed(response) );
        },

        formData: function () {
            return {
                red: this.red,
                amber: this.amber,
                green: this.green,
                blue: this.blue, 
            };
        },

        success: function () {            
            window.flash('Visit Frequency Updated');
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            VisitFrequencyService.get()
                .then( ({data}) => {
                    this.red = data.data.red;
                    this.amber = data.data.amber;
                    this.green = data.data.green;
                    this.blue = data.data.blue;
                    this.loading = false;
                });
        },
        hasError: function (key) {
            return (this.errors[key]);
        }
    },

    computed: {
        redHasError: function () { return this.hasError('red') },
        amberHasError: function () { return this.hasError('amber') },
        greenHasError: function () { return this.hasError('green') },
        blueHasError: function () { return this.hasError('blue') },
    }
}
</script>